import './AssetOrganization.css';
import AssetDiscovery from '../../components/AssetDiscovery/AssetDiscovery';
import AssetDistribution from '../../components/AssetDistribution/AssetDistribution';
import Distribution from '../../components/EffortlessDistribution/Distribution';

const AssetOrganization = () => {
    return (
        <div className='asset-organization'>
            {/* Hero Section */}
            <div className="asset-organization-hero">
                <div className="hero-content1">
                    <h1 className="title-text">
                        Smart Asset Organization<br />
                        Built to Grow With You.
                    </h1>
                    <p className="description-text">
                        Keep your assets structured, searchable, and ready to use—anytime, anywhere.
                    </p>
                </div>
            </div>

            {/* Component Sections */}
            <div id="asset-distribution">
                <AssetDistribution />
            </div>
            <div id="asset-discovery">
                <AssetDiscovery />
            </div>
            <div id="distribution">
                <Distribution />
            </div>
        </div>
    )
}

export default AssetOrganization;